import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";

const Logout = () => {
  const { instance } = useMsal();
  useEffect(() => {
    instance?.logoutRedirect();
  }, []);
  return null;
};

export default Logout;
